module.exports = __webpack_public_path__ + "media/images/icons/envelope-612eb5c9fd463b9d255142de97006dd1.svg";